import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { getFinanceCommissionAccountByFinanceCommissionId, setPayeeInfo, setFinanceCommissionAccountByFinanceCommissionId } from '@/api/financial-center'
import { payInfoList } from '@/api/common'
import { menuBtn } from '@/utils/menu_level2_button'
import { delNullProperty } from "@/utils";

@Component({})
export default class BackMoneyParnterInfo extends Vue {
    newAccountDialog = false //新增收款账户
    accountTypeList = [
        {value: 'PUBLIC', label: '对公账户'},
        {value: 'PERSONAL', label: '个人账户'},
    ]
    type:any = '' //账户类型
    // typeOwner = '' //所有者类型
    name:any = '' //开户名称
    cardNum:any = '' //银行卡号
    branch:any = '' //开户网点
    payeeInfoId:any = '' //新建返佣需要
    payInfo:any = {
        name: '',
        cardNum: '',
        branch: '',
        price: '',
        type: '',
        page: 1,
        limit: 20,
        id: '',
    }
    payInfoLoading = false
    payeeInfoList = [] // 开户名称数据
    total: 0
    accountEditBtn = false

    logShow = true
    financeCommissionId = NaN //返佣id
    backMoneyInfo: any = ''
    infoStatus: any = ''
    status = ''
    isShow = ''
    fileList = []
    fileList1 = []
    proofArr = {}
    turnParagraphArr = []
    moneyCertificatesArr = []
    isUpdatedData = '0'
    searchName: any =null //开户名称
    searchCardName: any =null //银行卡号

    menuBtn = menuBtn

    created() {
        this.financeCommissionId = Number(this.$route.query.id)
        this.isUpdatedData = this.$route.query.isUpdatedData as string || '0'
        // this.infoStatus = this.$route.query.status
        this.getFinanceCommissionAccountByFinanceCommissionId()
        if(this.$route.query.status) this.status = this.$route.query.status as string
        if(this.$route.query.isShow) this.isShow = this.$route.query.isShow as string
        this.payInfoList() //开户名称
    }

    formatDate = formatDate
    // 新增账户
    clickNewAccount(){
        this.newAccountDialog = true
    }
    // 新增账户确认
    async handleConfirmAccount() {
        if (this.type === '' ||  this.name === ''|| this.cardNum === ''|| this.branch === '') {
            this.$message.error(`请将${this.type === '' ? '账户类型，' : ''}${this.name === '' ? '开户名称，' : ''}${this.cardNum === '' ? '银行卡号，' : ''}${this.branch === '' ? '开户网点，' : ''}填写完整`)
            return
        }
        const obj = {
            type: this.type,
            name: this.name,
            cardNum: this.cardNum,
            branch: this.branch,
        }

        const data: any = await setPayeeInfo(obj)
        // this.payeeInfoId = data.payeeInfoId
        this.payInfo.name = this.name
        this.payInfo.cardNum = this.cardNum
        this.payInfo.branch = this.branch
        this.payInfo.type = this.type
        this.payInfo.id = data.payeeInfoId
        this.newAccountDialog = false
    }

    // 开户名称列表
    async payInfoList() {
        let objs = {
            name: this.searchName,
            cardNum: this.searchCardName,
            page: this.payInfo.page,
            limit: this.payInfo.limit,
        }
        const data: any = await payInfoList(delNullProperty(objs))
        this.payeeInfoList = [...this.payeeInfoList, ...data.payeeInfoList]
        let result = []
        let obj = {}
        for(let i =0; i<this.payeeInfoList.length; i++){
            if(!obj[this.payeeInfoList[i].name]){
                result.push(this.payeeInfoList[i]);
                obj[this.payeeInfoList[i].name] = true;
            }
        }
        this.payeeInfoList = result
    }
    async handlePayInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchName) && !this.payInfo.name){
            this.searchName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.name){
            this.payeeInfoList = []
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.payInfo.name })
            this.payeeInfoList = result.payeeInfoList
        }
    }
    async handleRemotePayInfo (query: any) {
        this.searchName = query
        this.payInfo.page = 1
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page,  name: query })
            this.payeeInfoList = result.payeeInfoList
        } else {
          this.payeeInfoList = []
            this.payInfoList();
        }
    }
    handlePayInfoLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }
    handleClearPayInfo() {
        this.searchName = null
        this.payInfo.cardNum = ''
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.payInfoList()
    }
    handlePayInfoChange (val) {
        this.payInfo.name = val
        let obj = this.payeeInfoList.find(item=> item.name === val)
        this.payInfo.cardNum = obj.cardNum
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.type = obj.type
    }
    // 银行卡号
    async handlePayCardInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchCardName) && !this.payInfo.cardNum){
            this.searchCardName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.cardNum){
            this.payeeInfoList = []
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.payInfo.cardNum })
            this.payeeInfoList = result.payeeInfoList
        }
    }
    async handleRemotePayCard (query: any) {
        this.searchCardName = query
        this.payInfo.page = 1
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page,  name: query })
            this.payeeInfoList = result.payeeInfoList
        } else {
          this.payeeInfoList = []
            this.payInfoList();
        }
    }
    handlePayCardLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }
    handleClearPayCard() {
        this.payInfo.name = ''
        this.searchCardName = null
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.payInfoList()
    }
    handlePayChangeCard (val) {
        this.payInfo.cardNum = val
        let obj = this.payeeInfoList.find(item=> item.cardNum === val)
        this.payInfo.name = obj.name
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.type = obj.type
    }



    async getFinanceCommissionAccountByFinanceCommissionId() {
        const data: any = await getFinanceCommissionAccountByFinanceCommissionId({ financeCommissionId: this.financeCommissionId })
        if(data.financeCommissionAccount){
            this.payInfo = data.financeCommissionAccount
            this.accountEditBtn = true
        }
        if(data.financeCommissionAccount){
            // 0=>未打款; 1=>打款中; 2=>已打款
            if(data.financeCommissionAccount.status == '0'){
                return this.payInfo.status = '未打款'
            }else if(data.financeCommissionAccount.status == '1'){
                return this.payInfo.status = '打款中'
            }else if(data.financeCommissionAccount.status == '2'){
                return this.payInfo.status = '已打款'
            }else if(data.financeCommissionAccount.status == '3'){
                return this.payInfo.status = '同步失败'
            }

        }

    }
    // 提交
    handleSave() {
        setFinanceCommissionAccountByFinanceCommissionId({
            financeCommissionId: this.financeCommissionId,
            payeeInfoId: this.payInfo.id,
        }).then(res => {
            this.$message.success('提交成功')
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            if (err.message == '审批流报错') {
            }
        })
    }
}
